import { PropsWithChildren } from 'react';

import clsx from 'clsx';

const createInfoIconComponent = (className: string) =>
  function InfoIconComponent({
    className: classNameProp,
    ...props
  }: PropsWithChildren<{
    className?: string;
  }>) {
    return (
      <i
        className={clsx(className, 'fa-info-circle', classNameProp)}
        {...props}
      />
    );
  };

export const InfoIconSolid = createInfoIconComponent('fas');
export const InfoIconOutline = createInfoIconComponent('far');
export default InfoIconSolid;
